export default __webpack_public_path__ + "static/media/noPreviewAvailable.3b43e327.png";